import {
    TABLE_SIZE_L, TABLE_SIZE_S
} from "../../../../../../contratto-digitale/digital-contract-details/tabs/offerte/OfferteHelper";

export const headCells = [
    {
        id: "nome",
        text: "",
        width: TABLE_SIZE_S,
        align: "left"
    },
    {
        id: "contenuto",
        text: "contenuto",
        width: TABLE_SIZE_L,
        align: "left"
    }
]